module.exports = __webpack_public_path__ + "static/media/1026222.71e89c34.jpg";